import SVGProps from 'src/components/icons/config/svg-props' //
// Auto-generated file created by svgr-cli source svg-template.cjs
// Run npm run generate-icons to update
// Do not edit
const SvgDeactivateUserIcon = (props: SVGProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props.size || '1em'}
    height={props.size || '1em'}
    fill="none"
    viewBox="0 0 64 64"
    role="img"
    className="icon"
    {...props}
  >
    <g fill="currentColor">
      <path
        fillRule="evenodd"
        d="M9.2 30.6c0-12.371 10.029-22.4 22.4-22.4S54 18.229 54 30.6q0 1.17-.117 2.308c1.056.64 2.033 1.4 2.91 2.26.268-1.483.407-3.009.407-4.568C57.2 16.462 45.739 5 31.6 5 17.462 5 6 16.462 6 30.6c0 9.785 5.49 18.285 13.55 22.592a25.5 25.5 0 0 0 13.229 2.981 16 16 0 0 1-1.852-3.183 22.3 22.3 0 0 1-8.759-2.066l2.075-8.3a3.2 3.2 0 0 1 3.105-2.424h3.584a16 16 0 0 1 1.867-3.2h-5.451a6.4 6.4 0 0 0-6.21 4.848l-1.864 7.459C13.202 45.297 9.2 38.415 9.2 30.6m19.2-12.8a3.2 3.2 0 0 0-3.2 3.2v8a3.2 3.2 0 0 0 3.2 3.2h6.4A3.2 3.2 0 0 0 38 29v-8a3.2 3.2 0 0 0-3.2-3.2zm0 11.2v-8h6.4v8z"
        clipRule="evenodd"
      />
      <path d="m43.913 46.8-5.656-5.657 1.885-1.886 5.657 5.657 5.657-5.657 1.885 1.886-5.656 5.656 5.656 5.657-1.885 1.886-5.657-5.657-5.657 5.657-1.886-1.886z" />
    </g>
  </svg>
)
export default SvgDeactivateUserIcon
